import { render, staticRenderFns } from "./ReviewsHeader.vue?vue&type=template&id=6813fe56&scoped=true"
import script from "./ReviewsHeader.vue?vue&type=script&lang=js"
export * from "./ReviewsHeader.vue?vue&type=script&lang=js"
import style0 from "./ReviewsHeader.vue?vue&type=style&index=0&id=6813fe56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6813fe56",
  null
  
)

export default component.exports